/**
 * Procedure Categories and Procedures for MD in Microbiology students
 * Extracted with strict evidence from official NMC PDF
 */
export const MICROBIOLOGY_PROCEDURES = {
  "Direct Microscopy & Staining Techniques": [
    "Saline & Iodine Wet Mount Stool Examination for Parasites",
    "Potassium Hydroxide (KOH) Mount for Fungi",
    "Gram Staining of Clinical Specimens",
    "Acid-Fast Bacilli (ZN Stain) & Modified Kinyoun Staining",
    "Leishman & Giemsa Staining for Blood Parasites",
    "Albert Staining for Corynebacterium diphtheriae",
    "Auramine O Fluorescent Staining for Mycobacteria",
    "Calcofluor White Fluorescent Staining for Fungi",
  ],
  "Pathogen Culture, Isolation & Identification": [
    "Culture Media Preparation, Sterilisation & Quality Control",
    "Specimen Inoculation (Streak, Surface, Stab Methods)",
    "Aerobic, Anaerobic, and Microaerophilic Incubation",
    "Pathogen Colony Morphology & Hanging Drop Motility Testing",
    "Biochemical Reaction Battery Testing (Enzymatic & Sugar Fermentation)",
    "Bacterial & Fungal Serotyping",
  ],
  "Antimicrobial Susceptibility & Drug Resistance Testing": [
    "Kirby-Bauer Disk Diffusion Antimicrobial Susceptibility Testing",
    "Broth Microdilution Testing for Minimum Inhibitory Concentration (MIC)",
    "Phenotypic & Genotypic Detection of Resistant Strains (MRSA, VRE, CRE, ESBL, MBL)",
  ],
  "Serology & Molecular Diagnostics": [
    "Rapid Diagnostic Tests, Latex Agglutination & Immunochromatographic Tests (ICT)",
    "Enzyme-Linked Immunosorbent Assay (ELISA)",
    "Polymerase Chain Reaction (Conventional & Real-Time PCR / RT-PCR)",
    "Cartridge-Based Nucleic Acid Amplification Test (CBNAAT / GeneXpert)",
  ],
};

export const MICROBIOLOGY_CATEGORIES = Object.keys(MICROBIOLOGY_PROCEDURES);

export const isMDInMicrobiologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("microbiology");
};
